<template>
  <div class="home">
    <h1 class="mt-16 text-h4 font-weight-bold text-center">
      {{ $city.name }}政府健檢預約平台
    </h1>
    <h2 class="my-4 text-h5 font-weight-bold text-center">
      {{ person.姓名 }}您好，您今年可以進行的檢查項目如下：
    </h2>
    <v-row class="mt-16 mx-0" justify="center">
      <v-col class="col-auto" v-for="(value, key) of validItem" :key="key">
        <div class="mb-4">
          <v-img
            contain
            max-height="50"
            :src="items[key].logo"
            alt=""
          ></v-img>
        </div>
        <h3
          class="font-weight-bold text-h6 text-center red--text text--darken-2"
        >
          {{ items[key].title }}
        </h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="text-center font-weight-bold text-h5">
        本市於
        {{ $city.districtNum }}
        區各別辦理數場檢查，若欲預約，請勾選同意進行檢查並繼續
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col
        class="py-0 my-0"
        cols="12"
        v-for="(value, key) of validItem"
        :key="key"
      >
        <div class="item-checkbox mx-auto">
          <v-checkbox
            v-model="person.篩檢項目[key]"
            :label="`我同意進行${items[key].title}`"
            hide-details
          ></v-checkbox>
        </div>
        <div
          v-if="items[key].notice"
          class="item-notice mx-auto mt-1 mb-2 grey--text text--darken-1"
        >
          {{ items[key].notice }}
        </div>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col class="col-auto">
        <v-btn
          @click="$router.go(-1)"
          class="mt-12 px-12 mx-2"
          x-large
          color="primary"
        >
          上一頁
        </v-btn>
        <v-btn @click="save" class="mt-12 px-12 mx-2" x-large color="primary"
          >前往預約</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { 健檢項目 } from "@/libs/const.js";
import _ from "lodash";
export default {
  name: "ItemConfirm",
  data: () => ({
    valid: false,
    person: null,
    items: 健檢項目,
  }),
  computed: {
    validItem() {
      return _.pickBy(this.person.可篩檢項目, (value) => value);
    },
  },
  async created() {
    this.person = { ...this.$store.state.person };
    this.person.篩檢項目 =
      this.person.篩檢項目 || _.cloneDeep(this.person.可篩檢項目);
  },
  methods: {
    save: async function () {
      if (!_.find(this.person.篩檢項目, (value) => value)) {
        this.$toast.error("沒有勾選任和篩檢項目！");
      } else {
        let cancelItem = _.pickBy(this.person.篩檢項目, (value) => !!!value);
        _.each(cancelItem, (value, key) => {
          this.person.篩檢項目[key] = false;
        });
        _.each(this.person.可篩檢項目, (value, key) => {
          if (!value) {
            this.person.篩檢項目[key] = false;
          }
        });
        this.$store.commit("setState", { person: this.person });
        this.$router.push("/questionnaire/1");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.item-checkbox {
  width: 230px;
}
.item-notice {
  max-width: 720px;
  font-size: 0.8125rem;
  line-height: 1.6;
}
</style>
